import { render, staticRenderFns } from "./MenuSection.vue?vue&type=template&id=09adc614&scoped=true"
import script from "./MenuSection.vue?vue&type=script&lang=js"
export * from "./MenuSection.vue?vue&type=script&lang=js"
import style0 from "./MenuSection.vue?vue&type=style&index=0&id=09adc614&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09adc614",
  null
  
)

export default component.exports